import amplitudeCore from 'amplitude-js';

let app: any = null;

const init = async (userId: string) => {
  try {
    if (typeof window !== 'undefined') {
      if (!app) {
        app = amplitudeCore.getInstance();
        app.init(process.env.NEXT_PUBLIC_AMPLITUDE_KEY, userId, { includeUtm: true });
      }
    }
  } catch (e) {
    //
  }
};

const setId = (id: string | null) => {
  try {
    if (app.options.userId !== id) {
      app.setUserId(id);
    }
  } catch (e) {
    //
  }
};

const setUserProperties = (params: { data: {};}) => {
  try {
    app.setUserProperties(params.data);
  } catch (e) {
    //
  }
};

const sendEvent = (eventName: string, data: any = {}) => {
  try {
    app.logEvent(eventName, data);
  } catch (e) {
    //
  }
};

const removeUser = () => {
  try {
    // const data = new amplitudeCore.Identify().unset('role');
    setId(null);

    // app.regenerateDeviceId();
    // app.identify(data);
  } catch (e) {
    //
  }
};

export {
  init,
  sendEvent,
  setId,
  setUserProperties,
  removeUser,
};
